import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";
import UserEntityMemberInvitationsTable from "users/super-users/_views/user-administration/pending-user-entity-member-invitations-table";

const StyledInvitationsContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  position: "relative",
  overflowY: "auto",
  height: "100%",
  width: "100%",
}));

/**
 * Every organisation's active member invitations. The table asks the server for each page and shows
 * its own loading and error states (#5447).
 */
export default function ActiveUserInvitationsPage() {
  return (
    <StyledInvitationsContainer>
      <UserEntityMemberInvitationsTable />
    </StyledInvitationsContainer>
  );
}
